export default __webpack_public_path__ + "static/media/business-903.9b330bcf.png";